import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import Alert from "react-s-alert";
import * as Yup from "yup";
import { Button, Modal } from "react-bootstrap";
import {
  Input as FormikInput
} from "../../formik";
import Actions from "../../redux/actions";

const NewLogin = ({ token, intl, setToken, dispatch }) => {
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);

  const PasswordSchema = Yup.object().shape({
    password: Yup.string().required().min(6,
      intl.formatMessage({
        id: "error.atleast6"
      })

    ),
    confirmPassword: Yup.string().when("password", {
      is: val => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf(
        [Yup.ref("password")],
        intl.formatMessage({
          id: "error.passnomatch"
        })
      )
    })
  });

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email().required()
  });

  const userLogin = (user) => {
    Alert.warning(intl.formatMessage({ id: "user.authenticating" }));
    dispatch(Actions.userLogin(user))
      .then(resp => {
        Alert.success(intl.formatMessage({ id: resp.message }));
        localStorage.setItem("logged_in", "true");
      }
      )
      .catch(err =>
        Alert.error(intl.formatMessage({ id: 'err.message' }))
      );
  }

  const handleForgotPassword = (values) => {
    fetch(
      `${process.env.REACT_APP_API_HOST}/user/forgot`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: values.email,
          redirect: `${process.env.REACT_APP_MANAGER_SITE_ROOT}?resettoken=`
        })
      }
    )
      .then(res => res.json())
      .then(function (resp) {
        if (resp.statusCode === 201) {
          Alert.success(
            intl.formatMessage({
              id: resp.message
            })
          );
          setShowForgotPasswordModal(false);
        } else {
          Alert.error(
            intl.formatMessage({
              id: resp.message
            })
          );
        }
      })
      .catch(function (err) {
        Alert.error(
          intl.formatMessage({
            id: "error.network-error"
          })
        );
      });
  };

  return (
    <div className="login-left text-center">
      <h3 className="text-primary">{intl.formatMessage({ id: "have.account" })}</h3>
      {
        token && <Formik
          validationSchema={PasswordSchema}
          onSubmit={(values) => {
            fetch(
              `${process.env.REACT_APP_API_HOST}/user/reset`,
              {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  token,
                  password: values.password
                })
              }
            )
              .then(res => res.json())
              .then(function (resp) {
                if (resp.statusCode === 201) {
                  Alert.success(
                    intl.formatMessage({
                      id: resp.message
                    })
                  );
                  setToken(null);
                } else {
                  Alert.error(
                    intl.formatMessage({
                      id: resp.message
                    })
                  );
                }
              })
              .catch(function (err) {
                Alert.error(
                  intl.formatMessage({
                    id: "error.network-error"
                  })
                );
              });
          }}
          initialValues={
            {
              password: '',
              confirmPassword: '',
            }
          }
        >
          {({ values }) => {
            return (
              <Form>
                <Field
                  component={FormikInput}
                  type="password"
                  name="password"
                  // label={intl.formatMessage({
                  //   id: "input.password"
                  // })}
                  placeholder={`${intl.formatMessage({
                    id: "input.password"
                  })}*`}
                  required
                />
                <Field
                  component={FormikInput}
                  type="password"
                  name="confirmPassword"
                  // label={intl.formatMessage({
                  //   id: "input.password.confirm"
                  // })}
                  placeholder={`${intl.formatMessage({
                    id: "input.password.confirm"
                  })}*`}
                  required
                />
                <Button

                  type="submit"
                  className=""
                >
                  {intl.formatMessage({
                    id: "button.changePassword"
                  })}
                </Button>
              </Form>
            )
          }}
        </Formik>
      }

      {
        !token && <Formik
          initialValues={
            {
              email: '',
              password: ''
            }
          }
          onSubmit={(values) => userLogin(values)}
        >
          {({ values }) => {
            return (
              <Form>
                <Field
                  component={FormikInput}
                  type="text"
                  name="email"
                  // label={intl.formatMessage({
                  //   id: "input.email"
                  // })}
                  placeholder={`${intl.formatMessage({
                    id: "input.email"
                  })}*`}
                  required
                />
                <Field
                  component={FormikInput}
                  type="password"
                  name="password"
                  // label={intl.formatMessage({
                  //   id: "input.password"
                  // })}
                  placeholder={`${intl.formatMessage({
                    id: "input.password"
                  })}*`}
                  required
                />
                {/* Forgot password section */}
                <Button
                  variant="link"
                  onClick={() => setShowForgotPasswordModal(true)}
                >
                  {intl.formatMessage({
                    id: "forgot.password"
                  })}
                </Button>
                <Button
                  type="submit"
                  className=""
                >
                  {intl.formatMessage({
                    id: "button.login"
                  })}
                </Button>
              </Form>
            )
          }}
        </Formik>
      }

      {/* Forgot Password Modal */}
      <Modal
        className="list-modal-form"
        show={showForgotPasswordModal}
        onHide={() => setShowForgotPasswordModal(false)}
      >
        <Modal.Header closeButton>
          <h4 className='text-primary'>{intl.formatMessage({ id: "forgot.password" })}</h4>
        </Modal.Header>
        <Modal.Body>
          {/* <label htmlFor="">Please enter your Email*</label> */}
          <Formik
            validationSchema={ForgotPasswordSchema}
            onSubmit={handleForgotPassword}
            initialValues={{
              email: ''
            }}
          >
            {({ values }) => {
              return (
                <Form>
                  <Field
                    component={FormikInput}
                    type="email"
                    name="email"
                    placeholder={`${intl.formatMessage({
                      id: "input.email"
                    })}*`}
                    required
                  />
                  <Button type="submit" className="mt-3"
                  style={{
                    color: 'white',
                  }}>
                    {intl.formatMessage({
                      id: "button.submit"
                    })}
                  </Button>
                </Form>
              )
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default NewLogin;